import React from "react";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import { Link } from "react-router-dom";

function CloudConnectivityQuality() {
  const { brandData } = useTraceabilityData()
  const brandName = brandData?.logo?.brandName;

  return (
    <div>
      <div class="wrapper2">
        <h2 class="heading2">Cloud Connectivity</h2>
      </div>
      <section class="py-0">
        <div class="container p-3">
          {/* <!-- more blogs --> */}
          <div class="row g-3">
            <div class="col-lg-4 col-12">

              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list">
                  <img src="img/smartfarm.png" alt="" class="card-img-top" />
                </div>
              </div>


              <p
                class="card-text text-muted py-1 px-1"
                style={{ marginLeft: "20px", fontSize: "12px" }}
              >
                At {brandName}, technology fuels precision and transparency.
                With IoT-driven solutions like ConTrak, we ensure real-time
                monitoring of milk quality at every stage. Our cloud-connected
                systems provide instant insights, empowering us to maintain the
                highest standards while streamlining supply chain operations.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div class="bg-light">
        <div class="container p-3">
          <h6 class="card-title fw-bold my-2">Our Connectivity Technology:</h6>
          <br />

          {/* <!--  <div class="d-flex align-items-center justify-content-between mb-3">
                  <h6 class="m-0">Popular Products</h6>
                  <a href="#">View all<i class="icofont-rounded-right"></i></a>
               </div>--> */}
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-1 g-3">

            <div class="product-item col">
              <div
                class="card h-100 rounded-4 overflow-hidden osahan-card-list"
                style={{ border: "0px" }}
              >
                <img src="img/contrak.jpg" alt="" class="card-img-top" />
                <h6
                  class="fw-normal"
                  style={{
                    fontSize: "13px",
                    textAlign: "left",
                    paddingTop: "10px",
                    color: "black",
                  }}
                >
                  <b>ConTrak</b>
                </h6>

                <style>
                  {`
      ul.custom-bullets {
        list-style: disc;
        padding-left: 1em;
      }
      ul.custom-bullets li {
        font-size: 12px;
        color: black;
        margin-bottom: 0.5em;
        text-indent: 0em;
        padding-left: 1em;
      }
    `}
                </style>

                <ul class="custom-bullets">
                  <li>
                    IoT-based cold chain monitoring solution that ensures milk
                    quality and safety throughout the supply chain.
                  </li>
                  <li>
                    Enables IoT-based, real-time management of cold chain with
                    enhanced reporting and improved monitoring through web and
                    mobile app portals.
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
      <div className="flex justify-between mt-10 px-4 mb-4 gap-10 sm:px-0">
        <Link
          to="/sustainability-in-quality-assurance"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Previous
        </Link>
        <Link
          to="/manufacturing"
          className="bg-[#4c922b] text-white py-2 px-6 rounded-lg w-full sm:w-auto inline-block text-center no-underline hover:no-underline"
        >
          Next
        </Link>

      </div>
      {/* <div class="bg-light">
        <div class="container p-3">
          <h6 class="card-title fw-bold my-2">Quality Check Insights</h6>

        
          <div class="row row-cols-xl-5 row-cols-lg-5 row-cols-md-3 row-cols-sm-3 row-cols-3 g-3">
            <a href="technology-driven-quality-tests">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Technology-Driven Quality Tests_.png"
                    alt=""
                    class="card-img-top"
                  />

                 
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

                 
                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1, top: "25%" }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Technology-Driven Quality Tests
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="sustainability">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Sustainability-in-Quality-Assurance_.png"
                    alt=""
                    class="card-img-top"
                  />

                
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

              
                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1, top: "25%" }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Sustainability in Quality Assurance
                      <br />
                    </h6>
                  </div>
                </div>
              </div>
            </a>

            <a href="cloud-connectivity">
              <div class="product-item col">
                <div class="card h-100 rounded-4 overflow-hidden osahan-card-list position-relative">
                  <img
                    src="img/Cloud-Connectivity_.png"
                    alt=""
                    class="card-img-top"
                  />

                
                  <div
                    class="position-absolute top-0 start-0 w-100 h-100"
                    style={{ background: "rgba(0, 0, 0, 0.4)" }}
                  ></div>

                 
                  <div
                    class="position-absolute text-overlay-f text-white p-3"
                    style={{ zIndex: 1 }}
                  >
                    <h6 class="fw-normal" style={{ fontSize: "12px" }}>
                      Cloud Connectivity
                    </h6>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div> */}
      {/* <Index/> */}
    </div>
  );
}

export default CloudConnectivityQuality;
